import styled from "styled-components";

import { COLOR_WHITE } from "@static/COLORS";

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${({ margin = "0px" }) => margin};
  background-color: ${({ color = "transparent" }) => `${color}`};
  font-weight: ${({ fontWeight = 500 }) => `${fontWeight}`};
  font-family: ${({ fontFamily = "IBM Plex Sans Thai" }) => fontFamily};
  font-size: ${({ fontSize = "14px" }) => fontSize};
  color: ${({ fontColor = COLOR_WHITE }) => fontColor};
  padding: ${({ padding = "5px 10px" }) => padding};
  width: ${({ width = "fit-content" }) => width};
  height: ${({ height = "fit-content" }) => height};
  border-radius: ${({ border = "4px" }) => border};
  &:disabled {
    opacity: 0.5;
  }
`;
